import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { Lock } from 'lucide-react';
import { EmptyState } from '@/components/ui/EmptyState';

export function AccessDenied(): ReactElement {
  return (
    <main className="flex h-screen items-center justify-center">
      <EmptyState
        icon={<Lock className="h-12 w-12" aria-hidden="true" />}
        title="Acceso denegado"
        description="No tienes los permisos necesarios para acceder a esta sección. Si crees que esto es un error, contacta al administrador de calidad."
        action={
          <Link to="/dashboard" className="text-primary-500 underline">
            Volver al inicio
          </Link>
        }
      />
    </main>
  );
}
